var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{attrs:{"id":"nav"}},[_c('a',{attrs:{"href":"https://wta-playerzone.com/Default_.aspx"}},[_c('img',{attrs:{"src":require("@/assets/WTA-Player-Zone_Headers.png"),"alt":"brand logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }